

























































































import Vue, { PropType } from 'vue';
import * as InputValidation from '@/mixins/inputValidation';
import * as Icons from '@/icons';

import Goal from '@/components/Goal.vue';
import Icon from '@/components/Icon.vue';
import IconPicker from '@/components/IconPicker.vue';

export default Vue.extend({
  components: {
    Goal,
    Icon,
    IconPicker
  },

  props: {
    objectiveName: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    iconData: {
      type: Object as PropType<Icons.IconData>,
      required: true
    },
    warning: {
      type: String,
      required: false
    },
    color: String
  },

  data() {
    return {
      nameInput: this.name,
      descriptionInput: this.description,
      goalIconData: this.iconData,
      goalColor: this.color,
      colorPickerColor: this.color,
      isPickingColor: false,
      isPickingIcon: false,
      nameMax: 250,
      descriptionMax: 1250
    };
  },

  computed: {
    isSaveDisabled(): boolean {
      return (
        (this.nameInput === this.name &&
          this.descriptionInput === this.description &&
          this.goalColor === this.color &&
          this.goalIconData.codePoint === this.iconData.codePoint) ||
        !this.nameValidation.valid ||
        !this.descriptionValidation.valid
      );
    },

    nameValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.nameInput, this.nameMax, true);
    },

    descriptionValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(
        this.descriptionInput,
        this.descriptionMax,
        true
      );
    }
  },

  methods: {
    saveGoal() {
      this.$emit('save', {
        name: this.nameInput,
        description: this.descriptionInput,
        iconData: this.goalIconData,
        color: this.goalColor
      });

      this.nameInput = this.name;
      this.descriptionInput = this.description;
      this.goalColor = this.color;
    },

    close() {
      this.$emit('close');
    },

    editColorStart() {
      this.colorPickerColor = this.goalColor;
      this.isPickingColor = true;
    },

    editColorStop() {
      this.isPickingColor = false;
    },

    selectColor() {
      this.goalColor = this.colorPickerColor;

      this.editColorStop();
    },

    selectIcon(iconData: Icons.IconData) {
      this.goalIconData = iconData;

      this.isPickingIcon = false;
    }
  },

  watch: {
    name(name) {
      this.nameInput = name;
    },

    description(description) {
      this.descriptionInput = description;
    },

    color(color) {
      this.goalColor = color;
    },

    iconData(iconData) {
      this.goalIconData = iconData;
    }
  }
});
